<template>
  <dh-header>
    Manage Job Types
    <template #buttons>
      <dh-button icon="export" variant="none" class="text-gray-500" @click="exportToCsv">Export to CSV</dh-button>
      <dh-button icon="add" variant="none" class="text-yellow-300" route="jobtypes.create">Add Job Type</dh-button>
    </template>
  </dh-header>
  <dh-table :rows="rows" :loading="loading" row-route="jobtypes.edit" :row-params="row => ({ id: row.id })">
    <dh-table-column label="Name" value="name"></dh-table-column>
    <dh-table-column label="Priority Level" value="priorityLevel"></dh-table-column>
  </dh-table>
</template>

<script lang="ts">
import {defineComponent, inject, ref, watch} from "vue";
import DhHeader from "@/components/DhHeader.vue";
import DhTable from "@/components/DhTable.vue";
import DhTableColumn from "@/components/DhTableColumn.vue";
import DhButton from "@/components/DhButton.vue";
import {Equipment, equipment, jobTypes} from "@/api";
import { useRoute } from "vue-router";
import { useRemoteData } from "@/hooks/useRemoteData";
import eventemitter from "eventemitter3";
import {useRemoteList} from "@/hooks/useRemoteList";
import {useExportToCsv} from "@/hooks/useExportToCsv";

export default defineComponent({
  name: "Equipment",
  components: {
    DhButton,
    DhHeader,
    DhTable,
    DhTableColumn,
  },
  setup() {
    const [rows, pagination, loading] = useRemoteList(jobTypes.list);

    const exportToCsv = useExportToCsv({
      filename: "jobtypes.csv",
      action: () =>
        rows.value.map(row => ({
          Name: row.name,
          "Priority Level": row.priorityLevel,
        })),
    });

    return { rows, loading, exportToCsv };
  },
});
</script>
